import Joi from 'joi';
import { objectSchemaOf } from '../helpers';

export interface ISendAnnouncementParams {
  conversationId: string;
  text: string;
}

const sendAnnouncementParams = objectSchemaOf<ISendAnnouncementParams>({
  conversationId: Joi.string().required(),
  text: Joi.string().required(),
});

export const sendAnnouncementSchema = sendAnnouncementParams;
